import { Link } from 'react-router-dom'
import { ChevronRightIcon } from '@/shared/ui/icons/ChevronRightIcon'
import { PlusIcon } from '@/shared/ui/icons/ZoomIcons'

export function EmptyStateCard({
  illust,
  title,
  lines,
  actionText,
  actionTo,
}: {
  illust: string
  title: string
  lines?: string[] | undefined
  actionText?: string | undefined
  actionTo?: string | undefined
}) {
  return (
    <div className="flex w-full items-center justify-center gap-3 pt-2 pb-1.5">
      <img className="h-[84px] w-[130px] shrink-0 object-contain" src={illust} alt="" />
      <div className="flex min-w-0 flex-col items-start gap-1">
        <p className="text-body-md font-medium text-black-300">{title}</p>
        {lines !== undefined && lines.length > 0 && (
          <p className="text-body-sm-reading text-black-200">
            {lines.map((line, i) => (
              <span key={line}>
                {i > 0 && <br />}
                {line}
              </span>
            ))}
          </p>
        )}
        {actionText !== undefined && actionTo !== undefined && (
          <Link className="ui-pressable inline-flex h-9 items-center justify-center gap-1 rounded-lg border border-transparent px-0 py-2.5 text-label font-medium whitespace-nowrap text-violet-700" to={actionTo}>
            {actionText}
            <ChevronRightIcon size={16} />
          </Link>
        )}
      </div>
    </div>
  )
}

export function EmptyStatePage({
  illust,
  title,
  lines,
  actionText,
  actionTo,
}: {
  illust: string
  title: string
  lines: string[]
  actionText: string
  actionTo: string
}) {
  return (
    <div className="flex flex-col items-center gap-[25px] px-4 pt-20">
      <img className="aspect-[343/228] w-full max-w-[343px] object-contain" src={illust} alt="" />
      <div className="flex w-[230px] flex-col items-center gap-3 text-center">
        <p className="text-body-lg leading-[1.4] font-medium text-black-600">{title}</p>
        <p className="text-body-md-reading text-black-300">
          {lines.map((line, i) => (
            <span key={line}>
              {i > 0 && <br />}
              {line}
            </span>
          ))}
        </p>
      </div>
      <Link className="ui-pressable mt-px inline-flex h-10 w-[230px] items-center justify-center gap-1.5 rounded-[10px] border border-transparent bg-violet-500 px-3 py-2.5 text-body-sm font-semibold whitespace-nowrap text-white-50" to={actionTo}>
        <PlusIcon size={20} />
        {actionText}
      </Link>
    </div>
  )
}
